import type { LiveSpeech } from '@edge/edge-ai'
import { createAuraSpeech } from '@/components/chat/voice/aura-stream-speech'
import { createPcmPlayer } from '@/components/chat/voice/pcm-player'
import { useLanguageStore } from '@/stores/language-store'

/**
 * The live speech session the companion speaks voice replies through: each
 * sentence is sent to Aura as it completes, so the first words play while the
 * rest is still being written. The same transport the direct analyst route
 * uses. Throws when audio is unavailable; the manager then falls back to
 * speaking the finished reply as one clip.
 */
export function openLiveSpeech(): LiveSpeech {
  return createAuraSpeech({
    language: useLanguageStore.getState().language,
    sink: createPcmPlayer(),
  })
}
